<template>
  <div id="myInvoice">

    <div class="title">
      <van-icon size="20" name="arrow-left" @click="$router.back()" />
      <span style="color:#333; margin-left:35%; font-size:16px">我的发票</span>
    </div>

    <div class="privilege">
      <div class="orderList" v-for="item in myInvoiceData" :key="item.orderid">
        <van-cell class="first-cell" title="订单编号" :value="item.orderid" />
        <van-cell title="订单明细" :value="item.product_desc" />
        <van-cell title="实付金额"  value="￥" >
          <template #right-icon>
            {{item.actualamount | toDecimal}}
          </template>
        </van-cell>
        <van-cell title="发票状态" :value="item.invoicestatusdesc" />
        <div class="listItem">
          <div class="leftWord">发票操作</div>
          <div class="rightWord last-right-word">
            <van-button
              :disabled="item.invoicestatus !== 1 || item.paystatus !== 100"
              size="small"
              @click="openInvoiceBtn(item, 1)"
              style="
                margin-right: 5px;margin-bottom:5px;
              "
              >开具发票</van-button
            >
            <!-- <van-button
              :disabled="item.invoicestatus !== 901"
              size="small"
              @click="sendPhoneBtn(item)"
              style="
                margin-right: 5px;margin-bottom:5px;
              "
              >发送手机</van-button
            >
            <van-button
              :disabled="item.invoicestatus !== 901"
              size="small"
              @click="sendEmailBtn(item)"
              style="
                margin-right: 5px;margin-bottom:5px;
              "
              >发送邮箱</van-button
            > -->

            <van-button
              :disabled="!item.allowinvoicereplace"
              size="small"
              @click="openInvoiceBtn(item, 2)"
              style="
                margin-right: 5px;margin-bottom:5px;
              "
              >申请换开</van-button
            >
          </div>
        </div>
      </div>
      <div v-if="this.myInvoiceData === null" class="orderList">
        <van-empty description="暂无数据" />
      </div>
    </div>

    <!-- 发送邮箱 -->
    <van-popup
      v-model="sendEmailShow"
      round
      style="width:90%;"
      closeable
      @close="closeSendInvoice"
    >
      <van-form @submit="submitInvoiceEmail" style="margin:10px 10px">
        <van-field
          v-model="sendInvoiceReq.postemail"
          name="邮箱"
          label="邮箱"
          colon
          label-width="40px"
          placeholder="请输入邮箱"
          :show-error="false"
          :rules="[
            {
              pattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/,
              message: '请输入正确的邮箱地址',
            },
          ]"
        />

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </van-popup>

    <!-- 发送手机 -->
    <van-popup
      v-model="sendPhoneShow"
      round
      style="width:90%;"
      closeable
      @close="closeSendInvoice"
    >
      <van-form @submit="submitInvoiceEmail" style="margin:10px 10px">
        <van-field
          v-model="sendInvoiceReq.postmobile"
          type="phone"
          name="手机"
          label="手机"
          colon
          label-width="40px"
          placeholder="请填写手机"
          :rules="[
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码' },
          ]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </van-popup>

    <!-- 发票弹框组件 -->
    <!-- :change-invoice="true" -->
    <invoice-page
      ref="invoice"
      @getInvoiceParams="getInvoiceParams"
      @clearInvoiceParams="clearInvoiceParams"
    ></invoice-page>

    <!-- 预览发票 -->
    <van-image-preview
      v-model="invoiceShow"
      :images="invoiceImages"
      closeOnPopstate
      closeable
    >
    </van-image-preview>
  </div>
</template>

<script>
import { ImagePreview } from "vant";

import CloseButton from "@/components/common/closebutton";
import InvoicePage from "@/components/common/invoice";

export default {
  data() {
    return {
      myInvoiceData: [],
      invoiceShow: false,
      invoicePdfUrl: "",

      // 图片预览
      invoiceImages: [],
      index: 0,

      sendEmailShow: false,
      sendPhoneShow: false,

      sendInvoiceReq: {
        orderid: "",
        postemail: "",
        postmobile: "",
      },

      sendEmail: false,

      // 申请换开接口参数
      changeInvoiceReqBody: {
        orderid: "",
        invoicetype: 0,
        invoiceheader: {
          headertype: 0,
          headername: "",
          headercode: "",
          officeaddress: "",
          mobilenumber: "",
          bankname: "",
          bankaccount: "",
          postaddress: "",
          postemail: "",
          postmobile: "",
        },
      },

      // 开票方式 1开票  2重开
      invoiceBtnType: 1,
    };
  },
  components: {
    CloseButton,
    InvoicePage,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .reqGetOrderInvoiceList()
        .then((res) => {
          this.myInvoiceData = res.items;
        })
        .catch((err) => {
          //console.log("获取发票", err);
          // this.$toast({
          //   duration: 5000,
          //   message: "服务器开小差啦,请刷新后重试!",
          // });
        });
    },

    // 暂时不放开发送手机逻辑
    sendPhoneBtn(item) {
      if (item.invoicestatus !== 901) {
        this.$dialog({
          message: item.invoicestatusdesc,
        });
      } else {
        this.sendPhoneShow = true;
        this.sendEmail = false;
        this.sendInvoiceReq.orderid = item.orderid;
      }
    },

    sendEmailBtn(item) {
      if (item.invoicestatus !== 901) {
        this.$dialog({
          message: item.invoicestatusdesc,
        });
      } else {
        this.sendEmailShow = true;
        this.sendEmail = true;
        this.sendInvoiceReq.orderid = item.orderid;
      }
    },

    submitInvoiceEmail() {
      if (this.sendEmail && this.sendInvoiceReq.postemail === "") {
        return this.$notify({
          message: "请输入邮箱！",
          color: "#fff",
          background: "#F27852",
          duration: 5000,
        });
      } else if (!this.sendEmail && this.sendInvoiceReq.postmobile === "") {
        return this.$notify({
          message: "请输入手机！",
          color: "#fff",
          background: "#F27852",
          duration: 5000,
        });
      } else {
        this.$http
          .sendInvoiceToEmailOrPhone(this.sendInvoiceReq)
          .then((resp) => {
            if (resp.rtncode === 1) {
              if (resp.rltcode === 1) {
                this.$notify({
                  type: "success",
                  message: "发票发送成功！",
                  duration: 5000,
                });
                this.getData();
                this.closeSendInvoice();
              } else {
                this.$notify({
                  message: resp.rltdesc,
                  duration: 5000,
                  type: "warning",
                });
              }
            } else {
              this.$notify({
                message: resp.rtndesc,
                duration: 5000,
                type: "warning",
              });
            }
          })
          .catch((err) => {
            console.log("发送发票到邮箱err", err);
          });
      }
    },

    closeSendInvoice() {
      for (const key in this.sendInvoiceReq) {
        this.sendInvoiceReq[key] = "";
      }
      this.sendEmailShow = false;
      this.sendPhoneShow = false;
    },

    // 预览发票
    seeInvoice(item) {
      /* if (item.invoicepicurl === "") {
        this.$notify({
          message: "查看发票失败，请稍后重试！",
          type: "warning",
          duration: 5000,
        });
        return;
      } */
      // this.invoiceImages[0] =
      // "https://invtest.nntest.cn/fp/WKG12podqbDeC0Lu2g7_UJDOBTEbMaidgmEF-uFFkOgxAMa4KtZlb2OtOfFfvhpIX8w3-nPu8TCE1swFc9D0Eg.jpg";
      this.invoiceImages[0] = item.invoicepicurl;
      this.invoiceShow = true;
    },

    // 打开发票框
    openInvoiceBtn(item, invoiceBtnType) {
      this.invoiceBtnType = invoiceBtnType;
      this.changeInvoiceReqBody.orderid = item.orderid;
      // 请求获取已开过发票
      this.$http
        .getInvoiceHeader()
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              // 赋值到发票组件
              this.$refs.invoice.inputMsg(res.item);
            }
          }
        })
        .catch((err) => {
          console.log("我的发票页面获取发票err", err);
        });
      this.$refs.invoice.openpopup();
    },

    // 获取发票弹框内容
    getInvoiceParams(params, word) {
      this.changeInvoiceReqBody.invoiceheader = params.invoiceheader
      this.changeInvoiceReqBody.invoicetype = params.invoicetype;
      if (this.invoiceBtnType === 1) {
        // 新开发票
        this.sureAddInvoice();
      } else if (this.invoiceBtnType === 2) {
        // 重开发票
        this.sureChangeInvoice();
      }
    },

    // 确定开具发票
    sureAddInvoice() {
      if (
        this.changeInvoiceReqBody.invoiceheader.postemail &&
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          this.changeInvoiceReqBody.invoiceheader.postemail
        )
      ) {
        this.$notify({
          message: "请输入正确的邮箱地址！",
          duration: 5000,
          type: "warning",
        });
        return;
      }
      this.$dialog
        .confirm({
          message: "请仔细核对你的开票信息!",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.$http.sureReqInvoice(this.changeInvoiceReqBody).then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.$notify({
                  message: "开票成功，请稍后查看！",
                  duration: 5000,
                  type: "success",
                });
                this.getData();
                this.clearInvoiceParams();
              } else {
                this.$notify({
                  message: res.rltdesc,
                  duration: 5000,
                  type: "warning",
                });
              }
            } else {
              this.$notify({
                message: res.rtndesc,
                duration: 5000,
                type: "warning",
              });
            }
          });
        })
        .catch((err) => {
          console.log("开具发票err=>>>", err);
        });
    },

    clearInvoiceParams() {
      for (const key in this.changeInvoiceReqBody.invoiceheader) {
        if (key === "headertype") {
          this.changeInvoiceReqBody.invoiceheader[key] = 0;
        } else {
          this.changeInvoiceReqBody.invoiceheader[key] = "";
        }
      }
      this.$refs.invoice.show = false;
    },

    // 确定重开
    sureChangeInvoice() {
      if (
        this.changeInvoiceReqBody.invoiceheader.postemail &&
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          this.changeInvoiceReqBody.invoiceheader.postemail
        )
      ) {
        this.$notify({
          message: "请输入正确的邮箱地址！",
          duration: 5000,
          type: "warning",
        });
        return;
      }

      let reqBody = {
        orderid: this.changeInvoiceReqBody.orderid,
        invoice: this.changeInvoiceReqBody.invoicetype,
        invoiceheader: this.changeInvoiceReqBody.invoiceheader,
      };

      this.$dialog
        .confirm({
          message: "请仔细核对你的开票信息!",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.$http.reqInvoiceChange(reqBody).then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.$notify({
                  message: "开票成功，请稍后查看！",
                  duration: 5000,
                  type: "success",
                });
                this.getData();
                this.clearInvoiceParams();
              } else {
                this.$notify({
                  message: res.rltdesc,
                  duration: 5000,
                  type: "warning",
                });
              }
            } else {
              this.$notify({
                message: res.rtndesc,
                duration: 5000,
                type: "warning",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
#myInvoice {
  background-color: #F6F6F6;
  min-height: 100%;
  .title {
    padding: 10px 0;
    background-color: #fff;
    border-top: 1px solid #ddd;
    display: flex;
    align-items: center;
  }
  .privilege {
    font-size: 0.37333rem;
    margin-top: 10px;
    .orderList {
      background-color: #fff;
      margin-bottom: 10px;
      box-sizing: border-box;
      border-radius: 10px;
      .listItem {
        display: flex;
        align-items: stretch;
        margin: 8px 6px;
        .leftWord {
          flex: 0 0 56%;
          margin-left: 10px;
        }
        .rightWord {
          flex: 1;
          display: flex;
          align-items: flex-end;
        }
        .last-right-word {
          display: block;
          /deep/.van-button {
            background-color: #ECF3FF;
            color: #0084FF;
          }
        }
      }
      .first-cell {
        .van-cell__titel {
          flex: 1;
        }
        .van-cell__value {
          flex: 2;
        }
      }
    }
    /deep/.van-cell__title {
      color: #000;
      font-weight: 500;
    }
    /deep/.van-cell__value {
      color: #404040;
    }
  }
}
</style>
